import { PLACEHOLDER_BUTTON__bar } from './PLACEHOLDER_BUTTON__bar';

export function PLACEHOLDER_BUTTON__bar_6() {
  return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
}
